import { dictKeyByValue } from 'domain/util';

export const orderSideIdDict = { Comprar: 1, Vender: 2 } as const;
export type OrderSideIdKey = keyof typeof orderSideIdDict;
export const orderSideIdValueByKey = (value: number) => dictKeyByValue(orderSideIdDict, value);
